"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var ScrollBox = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollBox, _React$Component);

  function ScrollBox(props) {
    var _this;

    _classCallCheck(this, ScrollBox);

    _this = _possibleConstructorReturn(this, (ScrollBox.__proto__ || Object.getPrototypeOf(ScrollBox)).call(this, props));
    _this.myRef = _react.default.createRef();
    _this.state = {
      scrollTop: false,
      scrollLeft: false,
      scrollRight: false,
      scrollBottom: false
    };
    _this.calculateShadows = _this.calculateShadows.bind(_assertThisInitialized(_this));
    _this.windowListener = null;
    _this.scrollListener = null;
    return _this;
  }

  _createClass(ScrollBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.windowListener = window.addEventListener('resize', this.calculateShadows);
      this.scrollListener = this.myRef.current.addEventListener('scroll', this.calculateShadows);
      this.calculateShadows();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.windowListener) {
        window.removeEventListener(this.windowListener);
      }

      if (this.scrollListener) {
        this.scrollListener = this.myRef.current.removeEventListener(this.scrollListener);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = 'comp-scroll-box';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'scroll-wrapper',
        ref: this.myRef
      }, this.props.children));
    }
  }, {
    key: "calculateShadows",
    value: function calculateShadows() {
      var element = this.myRef.current;
      var scrollTop = false,
          scrollLeft = false,
          scrollRight = false,
          scrollBottom = false;

      if (element) {
        scrollTop = element.scrollTop > 0;
        scrollLeft = element.scrollLeft > 0;
        scrollRight = element.scrollLeft + element.clientWidth < element.scrollWidth;
        scrollBottom = element.scrollTop + element.clientHeight < element.scrollHeight;
      }

      this.setState({
        scrollTop: scrollTop,
        scrollLeft: scrollLeft,
        scrollRight: scrollRight,
        scrollBottom: scrollBottom
      });
    }
  }]);

  return ScrollBox;
}(_react.default.Component);

ScrollBox.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object])
};
var _default = ScrollBox;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/scroll-box/index.js
// module id = 334
// module chunks = 0